import { render, staticRenderFns } from "./ClientStatsChart.vue?vue&type=template&id=7c7e832c&scoped=true"
import script from "./ClientStatsChart.vue?vue&type=script&lang=js"
export * from "./ClientStatsChart.vue?vue&type=script&lang=js"
import style0 from "./ClientStatsChart.vue?vue&type=style&index=0&id=7c7e832c&prod&lang=less&scoped=true"
import style1 from "./ClientStatsChart.vue?vue&type=style&index=1&id=7c7e832c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7e832c",
  null
  
)

export default component.exports